<template>
    <div v-if="mostrar" class="modal-mask" @click.self="$emit('fechar')">
        <div class="jm margem pcm-modal-edicao" :class="{ 'pcm-modal-edicao--novo': isNovoResultado }" @click.stop>
            <h2 class="alinha-centro">{{ tituloModal }}</h2>
            <!-- Layout dedicado: novo resultado -->
            <fieldset v-if="!mensagemEdicao && isNovoResultado" class="pcm-modal-form-novo">
                <div class="pcm-modal-campo-bloco">
                    <label>Nome</label>
                    <input v-model="novoResultadoForm.nome" type="text"
                        placeholder="Título curto e identificável da entrega">
                </div>
                <div class="pcm-modal-campo-bloco">
                    <label>Especificação da entrega</label>
                    <textarea v-model="novoResultadoForm.descricao" rows="2"
                        placeholder="Qual estado concreto deverá existir ao final?"></textarea>
                </div>
                <div class="pcm-modal-campo-bloco">
                    <label>Evidências</label>
                    <textarea v-model="novoResultadoForm.evidencias" rows="2"
                        placeholder="Descreva as evidências..."></textarea>
                </div>
                <div class="pcm-modal-linha-dupla">
                    <div class="pcm-modal-campo-bloco">
                        <label>Data prevista de conclusão</label>
                        <input type="date" v-model="novoResultadoForm.dt_prevista_conclusao" />
                    </div>
                    <div class="pcm-modal-campo-bloco">
                        <label>Custo previsto</label>
                        <label class="pcm-check-sem-custo">
                            <input type="checkbox" v-model="novoResultadoForm.sem_custo" /> Esta entrega não terá
                            custo </label>
                        <money3 v-if="!novoResultadoForm.sem_custo" v-model="novoResultadoForm.custo" v-bind="config"
                            class="inputValor"></money3>
                        <p v-else class="pcm-aviso-sem-custo">Esta entrega não terá custo</p>
                    </div>
                </div>
                <div class="pcm-modal-campo-bloco">
                    <label>Justificativa</label>
                    <textarea v-model="localPedido.justificativa" rows="2" :required="!localPedido.justificativa"
                        placeholder="Por que esta entrega precisa ser incluída?"></textarea>
                </div>
                <div class="pcm-modal-campo-bloco">
                    <label>Observações (opcional)</label>
                    <textarea v-model="localPedido.obs" rows="2"
                        placeholder="Informações complementares à justificativa"></textarea>
                </div>
            </fieldset>
            <!-- Layout padrão: demais pedidos -->
            <fieldset class="grid-2" v-else-if="!mensagemEdicao">
                <div>
                    <label>{{ selecionarAtributo ? 'Campo a alterar' : 'Campo' }}</label>
                    <select v-if="selecionarAtributo" v-model="atributoSelecionado" @change="onAtributoSelecionado">
                        <option value="" disabled>Selecione o campo</option>
                        <option v-for="op in atributosOpcoes" :key="op.valor" :value="op.valor"> {{ op.label }}
                        </option>
                    </select>
                    <input v-else readonly type="text" :value="labelCampoExibicao">
                </div>
                <div>
                    <label>{{ parsedResultado?.tipo === 'excluir' ? 'Entrega' : 'Novo valor' }}</label>
                    <p v-if="selecionarAtributo && !atributoSelecionado" class="fonte-fraca"> Selecione o campo para
                        informar o novo valor. </p>
                    <textarea v-else-if="parsedResultado?.tipo === 'excluir'" readonly
                        :value="resumoExclusaoModal"></textarea>
                    <textarea v-else-if="localPedido.campo === 'resultados'" readonly
                        :value="'A solicitação irá atualizar a lista de entregas.'"></textarea>
                    <textarea v-else-if="localPedido.campo === 'objetivos_estrategicos'" readonly
                        :value="resumoObjetivosPedidoModal(localPedido)"></textarea>
                    <div v-else-if="metaCampo?.tipo === 'boolean'" class="pcm-check-sem-custo">
                        <label>
                            <input type="checkbox" :checked="boolNovoValor"
                                @change="onToggleSemCusto($event.target.checked)" /> Esta entrega não terá custo
                        </label>
                    </div>
                    <textarea v-else-if="metaCampo?.tipo === 'string'" :required="!localPedido.novo_valor"
                        v-model="localPedido.novo_valor"></textarea>
                    <input v-else-if="metaCampo?.tipo === 'date'" type="date" :required="!localPedido.novo_valor"
                        v-model="localPedido.novo_valor" />
                    <select v-else-if="metaCampo?.tipo === 'select' && metaCampo?.lista === 'usuarios'"
                        :required="!localPedido.novo_valor" v-model="localPedido.novo_valor">
                        <option :value="null" hidden>-</option>
                        <option v-for="u in usuarios" :key="u.id" :value="u.id">{{ u.nomeCompleto }}</option>
                    </select>
                    <select v-else-if="metaCampo?.tipo === 'select' && metaCampo?.lista === 'setores'"
                        :required="!localPedido.novo_valor" v-model="localPedido.novo_valor">
                        <option :value="null" hidden>-</option>
                        <option v-for="s in setores" :key="s.id" :value="s.id">{{ s.nome }}</option>
                    </select>
                    <select v-else-if="metaCampo?.tipo === 'select'" :required="!localPedido.novo_valor"
                        v-model="localPedido.novo_valor">
                        <option :value="null" hidden>-</option>
                        <option v-for="(o, index) in (metaCampo?.lista ?? [])" :key="index">{{ o }}</option>
                    </select>
                    <div v-else-if="metaCampo?.tipo === 'moeda'">
                        <label class="pcm-check-sem-custo" v-if="parsedResultado?.tipo === 'campo'">
                            <input type="checkbox" v-model="marcarSemCustoNoCusto"
                                @change="onMarcarSemCustoNoPedidoCusto" /> Esta entrega não terá custo </label>
                        <money3 v-if="!marcarSemCustoNoCusto" :required="!localPedido.novo_valor"
                            v-model="localPedido.novo_valor" v-bind="config" class="inputValor">
                        </money3>
                        <p v-else class="pcm-aviso-sem-custo">Esta entrega não terá custo</p>
                    </div>
                </div>
                <div><label>Justificativa</label>
                    <textarea v-model="localPedido.justificativa" :required="!localPedido.justificativa"></textarea>
                </div>
                <div><label>Observações (opcional)</label>
                    <textarea v-model="localPedido.obs"
                        placeholder="Informações complementares à justificativa"></textarea>
                </div>
            </fieldset>
            <div v-else class="alinha-centro">
                <span class="card" :class="mensagemEdicao.message ? 'txt-erro' : 'txt-sucesso'"> {{
                    mensagemEdicao.message ?? 'Solicitação Enviada!' }} </span>
            </div>
            <div class="submit direita">
                <button class="acao-secundaria" @click="$emit('fechar')">{{ mensagemEdicao ? 'Ok' : 'Cancelar'
                }}</button>
                <button v-if="!mensagemEdicao" :disabled="!podeSolicitar" @click="onSolicitar">Solicitar</button>
            </div>
        </div>
    </div>
</template>
<script>
import { Money3Component } from "v-money3";
import servicePCM from "@/services/servicePCM";

export default {
    name: "ModalSolicitarEdicaoPCM",
    components: { money3: Money3Component },
    props: {
        mostrar: { type: Boolean, default: false },
        pedidoEdicao: { type: Object, default: null },
        campos: { type: Object, default: () => ({}) },
        usuarios: { type: Array, default: () => [] },
        setores: { type: Array, default: () => [] },
        config: {
            type: Object,
            default: () => ({ masked: false, prefix: "R$ ", thousands: ".", decimal: ",", precision: 2 }),
        },
        mensagemEdicao: { type: Object, default: null },
        labelOverride: { type: String, default: null },
    },
    emits: ["fechar", "solicitar"],
    data() {
        return {
            localPedido: { campo: "", novo_valor: null, justificativa: "", obs: "" },
            novoResultadoForm: {
                nome: "",
                problema: "",
                descricao: "",
                evidencias: "",
                dt_prevista_conclusao: null,
                custo: null,
                sem_custo: false,
                status: "pendente",
            },
            marcarSemCustoNoCusto: false,
            atributoSelecionado: "",
        };
    },
    computed: {
        selecionarAtributo() {
            return Boolean(this.localPedido?._selecionarAtributo)
        },
        atributosOpcoes() {
            return Array.isArray(this.localPedido?._atributosOpcoes)
                ? this.localPedido._atributosOpcoes
                : []
        },
        parsedResultado() {
            return servicePCM.parseCampoPedidoResultado(this.localPedido?.campo)
        },
        isNovoResultado() {
            return this.parsedResultado?.tipo === "novo"
        },
        tituloModal() {
            if (this.isNovoResultado) return "Solicitar nova entrega"
            if (this.parsedResultado?.tipo === "excluir") return "Solicitar exclusão"
            if (this.selecionarAtributo) return "Solicitar edição de entrega"
            return "Solicitar Edição"
        },
        metaCampo() {
            return servicePCM.metaCampoPedido(this.localPedido?.campo)
                || this.campos[this.localPedido?.campo]
                || null
        },
        labelCampoExibicao() {
            if (this.labelOverride) return this.labelOverride
            if (this.pedidoEdicao?._label) return this.pedidoEdicao._label
            return servicePCM.labelCampoPedido(this.localPedido?.campo)
                || this.campos[this.localPedido?.campo]?.label
                || this.localPedido?.campo
        },
        boolNovoValor() {
            const v = this.localPedido.novo_valor
            return v === true || v === 1 || v === "1" || String(v).toLowerCase() === "true"
                || String(v).toLowerCase() === "sim"
        },
        resumoExclusaoModal() {
            return servicePCM.resumoExclusaoResultadoPedido(
                { valor_atual: this.localPedido.valor_atual },
                "atual",
            )
        },
        podeSolicitar() {
            if (!this.localPedido.justificativa) return false
            if (this.selecionarAtributo && !this.atributoSelecionado) return false
            if (this.parsedResultado?.tipo === "excluir") return true
            if (this.parsedResultado?.tipo === "novo") {
                return ["nome", "descricao", "evidencias"]
                    .every((campo) => !!String(this.novoResultadoForm[campo] || "").trim())
            }
            if (this.localPedido.campo === "resultados" || this.localPedido.campo === "objetivos_estrategicos") {
                return true
            }
            if (this.metaCampo?.tipo === "boolean") return true
            if (this.metaCampo?.tipo === "moeda" && this.marcarSemCustoNoCusto) return true
            return !!this.localPedido.novo_valor || this.localPedido.novo_valor === 0
        },
    },
    watch: {
        pedidoEdicao: {
            handler(val) {
                this.sincronizarLocal(val)
            },
            immediate: true,
            deep: true,
        },
        mostrar(visivel) {
            if (visivel && this.pedidoEdicao) {
                this.sincronizarLocal(this.pedidoEdicao)
            }
        },
    },
    methods: {
        sincronizarLocal(val) {
            this.localPedido = val
                ? { ...val, novo_valor: val.novo_valor ?? null, justificativa: val.justificativa ?? "", obs: val.obs ?? "" }
                : { campo: "", novo_valor: null, justificativa: "", obs: "" }

            this.atributoSelecionado = ""
            this.marcarSemCustoNoCusto = false

            const parsed = servicePCM.parseCampoPedidoResultado(this.localPedido.campo)
            if (parsed?.tipo === "novo") {
                const existing = servicePCM.parseJsonPedidoValor(this.localPedido.novo_valor)
                this.novoResultadoForm = {
                    nome: existing?.nome ?? "",
                    problema: existing?.problema ?? "",
                    descricao: existing?.descricao ?? "",
                    evidencias: existing?.evidencias ?? "",
                    dt_prevista_conclusao: existing?.dt_prevista_conclusao ?? null,
                    custo: existing?.custo ?? null,
                    sem_custo: !!(existing?.sem_custo),
                    status: "pendente",
                }
            }
            if (parsed?.tipo === "campo") {
                this.atributoSelecionado = parsed.atributo === "sem_custo" ? "custo" : parsed.atributo
            }
            if (parsed?.tipo === "campo" && parsed.atributo === "custo") {
                this.marcarSemCustoNoCusto = false
            }
            if (parsed?.tipo === "campo" && parsed.atributo === "sem_custo") {
                if (this.localPedido.novo_valor == null || this.localPedido.novo_valor === "") {
                    this.localPedido.novo_valor = "1"
                }
            }
        },
        valorAtualDoSnapshot(atributo) {
            const snap = this.localPedido?._resultadoSnapshot || {}
            if (atributo === "sem_custo") {
                return snap.sem_custo ? "1" : "0"
            }
            if (atributo === "custo") {
                if (snap.sem_custo || snap.custo === "" || snap.custo == null) return ""
                return String(snap.custo)
            }
            if (atributo === "dt_prevista_conclusao" || atributo === "dt_conclusao") {
                if (!snap?.[atributo]) return ""
                return String(snap[atributo]).slice(0, 10)
            }
            return snap?.[atributo] ?? ""
        },
        onAtributoSelecionado() {
            const atributo = this.atributoSelecionado
            if (!atributo || !this.localPedido?._resultadoId) return

            const campo = servicePCM.montarCampoPedidoResultado(this.localPedido._resultadoId, atributo)
            const meta = servicePCM.atributosResultado[atributo]
            this.localPedido.campo = campo
            this.localPedido.valor_atual = this.valorAtualDoSnapshot(atributo)
            this.localPedido.novo_valor = atributo === "sem_custo" ? "1" : null
            this.localPedido._tipo = meta?.tipo
            this.localPedido._label = servicePCM.labelCampoPedido(campo, {
                indice: this.localPedido._resultadoIndice,
            })
            this.marcarSemCustoNoCusto = false
        },
        onToggleSemCusto(checked) {
            this.localPedido.novo_valor = checked ? "1" : "0"
        },
        onMarcarSemCustoNoPedidoCusto() {
            if (this.marcarSemCustoNoCusto) {
                this.localPedido.novo_valor = null
            }
        },
        onSolicitar() {
            const parsed = this.parsedResultado
            const payload = { ...this.localPedido }

            if (parsed?.tipo === "novo") {
                const form = { ...this.novoResultadoForm }
                if (form.sem_custo) {
                    form.custo = null
                }
                payload.novo_valor = JSON.stringify(form)
            } else if (parsed?.tipo === "excluir") {
                payload.novo_valor = "(exclusão)"
            } else if (parsed?.tipo === "campo" && parsed.atributo === "custo" && this.marcarSemCustoNoCusto) {
                payload.campo = servicePCM.montarCampoPedidoResultado(parsed.resultadoId, "sem_custo")
                payload.valor_atual = this.pedidoEdicao?.valor_atual_sem_custo ?? "0"
                payload.novo_valor = "1"
            }

            this.$emit("solicitar", payload)
        },
        resumoObjetivosPedidoModal(pedido) {
            const proposto = (() => {
                try {
                    const parsed = JSON.parse(pedido?.novo_valor || '[]')
                    return Array.isArray(parsed) ? parsed : []
                } catch {
                    return []
                }
            })()
            if (!proposto.length) {
                return 'A solicitação irá remover todos os objetivos estratégicos vinculados.'
            }
            const nomes = proposto.map((item) => item.nome || `Objetivo #${item.objetivo_id}`).join('\n- ')
            return `Objetivos estratégicos selecionados na proposta:\n- ${nomes}`
        },
    },
};
</script>
<style scoped>
.pcm-modal-edicao {
    min-width: 60vw;
    max-width: 94vw;
    max-height: 85vh;
    overflow: auto;
}

.pcm-modal-edicao--novo {
    min-width: min(40rem, 94vw);
    width: min(42rem, 94vw);
}

.pcm-modal-form-novo {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    border: none;
    padding: 0;
    margin: 0;
}

.pcm-modal-form-novo label {
    margin-bottom: 0;
}

.pcm-modal-campo-bloco {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
}

.pcm-modal-campo-bloco label {
    margin: 0;
}

.pcm-modal-campo-bloco textarea,
.pcm-modal-campo-bloco input[type="date"],
.pcm-modal-campo-bloco .inputValor {
    width: 100%;
    box-sizing: border-box;
}

.pcm-modal-linha-dupla {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
}

@media (max-width: 640px) {
    .pcm-modal-linha-dupla {
        grid-template-columns: 1fr;
    }
}

.pcm-check-sem-custo {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    margin: 0.15rem 0 0.35rem;
    font-weight: normal;
}

.pcm-aviso-sem-custo {
    margin: 0;
    padding: 0.65rem 0.75rem;
    border-radius: 6px;
    font-size: 0.9rem;
    background: color-mix(in srgb, var(--cor-separador, #eee) 70%, transparent);
    color: var(--cor-texto-secundario, #555);
}

.inputValor {
    border: 1px solid var(--cor-separador);
    font-size: 16px;
    border-radius: 6px;
    height: 48px;
    padding: 12px 16px;
    width: 100%;
    box-sizing: border-box;
}
</style>
